module.exports = __webpack_public_path__ + "img/title.67f44924.png";